import styled from 'foundations-theming/utils';

// styled.td is required here because TableCell has no props for border-inline-end,
// border-inline-start, or border-block-start-color (non-token color value).
export const StyledTableCell = styled.td.withConfig({
  displayName: "StyledTableCell"
})(["&&{", " border-inline-end:none;border-inline-start:none;}&&:not(:first-child){", "}"], ({
  theme
}) => `
      border-block-start-color: ${theme.color['border-transitional-core-subtle']};
    `, ({
  theme
}) => `
      padding-inline: ${theme.space['400']};
    `);